export const formatDate = (value) => {
  if (!value) return "-";
  const str = String(value).slice(0, 10);
  const [y, m, d] = str.split("-");
  if (y && m && d) return `${d}-${m}-${y}`;
  return str;
};
